import { MIN_WIDTH_AI_CHAT_PANEL, MIN_WIDTH_SIDE_PEEK } from '@/lib/constants';

export const panel = {
  sidePeek: 'sidePeek',
  aiChat: 'aiChat',
};

export const minWidth = {
  [panel.sidePeek]: MIN_WIDTH_SIDE_PEEK,
  [panel.aiChat]: MIN_WIDTH_AI_CHAT_PANEL,
};

export const bothPanelsFit = (windowWidth) => windowWidth >= minWidth.sidePeek + minWidth.aiChat;

export const fitPanelWidths = ({ windowWidth, sidePeek, aiChat, dragged = null }) => {
  const widths = { sidePeek, aiChat };
  const overflow = sidePeek + aiChat - windowWidth;
  if (sidePeek === 0 || aiChat === 0 || overflow <= 0) {
    return widths;
  }

  const slack = {
    sidePeek: Math.max(0, sidePeek - minWidth.sidePeek),
    aiChat: Math.max(0, aiChat - minWidth.aiChat),
  };

  // the panel under the cursor keeps the width it asks for as long as the other one has
  // room to give, so a drag handle stays under the pointer instead of trailing behind it
  if (dragged !== null) {
    const other = dragged === panel.sidePeek ? panel.aiChat : panel.sidePeek;
    const taken = Math.min(overflow, slack[other]);
    return {
      ...widths,
      [other]: widths[other] - taken,
      [dragged]: Math.max(minWidth[dragged], widths[dragged] - (overflow - taken)),
    };
  }

  const total = slack.sidePeek + slack.aiChat;
  if (total === 0) {
    return widths;
  }

  const taken = Math.min(overflow, total);
  const fromSidePeek = Math.round((taken * slack.sidePeek) / total);
  return {
    sidePeek: sidePeek - fromSidePeek,
    aiChat: aiChat - (taken - fromSidePeek),
  };
};
